<ion-item
  class="default"
  [class.error]="hasError"
  lines="none"
>
  <ion-label
    position="stacked"
    class="ion-no-margin ion-text-wrap"
    *ngIf="label"
    #inputLabel
  >
    <span
      *ngIf="size === 'default'"
      class="default"
      >{{ label }}
      <span
        class="asterisk"
        *ngIf="isRequired"
        >*</span
      ></span
    >
    <h2
      *ngIf="size === 'large'"
      class="h2"
    >
      {{ label }}
      <span
        class="asterisk"
        *ngIf="isRequired"
        >*</span
      >
    </h2>
    <div>
      <ng-content select=".description"></ng-content>
    </div>
  </ion-label>
  <div class="control">
    <ion-icon
      *ngIf="icon"
      [name]="icon"
    ></ion-icon>
    <ng-content></ng-content>
  </div>
  <ng-content select=".misc"></ng-content>
  <div class="warning-container">
    <ion-icon
      slot="start"
      name="alert-circle"
    ></ion-icon>
    <ng-content select=".warn"></ng-content>
  </div>
  <div class="info-container">
    <ion-icon
      slot="start"
      name="information-circle"
    ></ion-icon>
    <ng-content select=".info"></ng-content>
  </div>
</ion-item>
